<script lang="ts" setup>
import { ref, onMounted } from 'vue'

const isClient = ref(false)

onMounted(() => {
  const isDev = import.meta.env.DEV
  if (isDev) {
    setTimeout(() => {
      isClient.value = true
    }, 0)
  } else {
    isClient.value = true
  }
})
</script>

<template>
  <slot v-if="isClient"
        name="default" />
  <slot v-else
        name="fallback" />
</template>
